__turbopack_context__.v({
  "accordion": "FinanceSummary-module__IZ_nla__accordion",
  "chevron": "FinanceSummary-module__IZ_nla__chevron",
  "wrapper": "FinanceSummary-module__IZ_nla__wrapper",
});
